var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeVenue)?_c('div',[_c('h3',[_vm._v("Old lists")]),_c('vs-tabs',{key:_vm.isSmallerScreen,staticClass:"tabs-shadow-none mt-2",attrs:{"position":"left","id":"profile-tabs"}},[(
        _vm.hasPermissionForActiveVenue(
          'vp.vp.lists.venuevisits.show'
        )
      )?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-info","label":!_vm.isSmallerScreen ? 'Venue Visits' : ''}},[_c('div',{staticClass:"lists-view-tab"},[_c('visits')],1)]):_vm._e(),(
        _vm.hasPermissionForActiveVenue(
          'vp.vp.lists.maintenancereviews.show'
        )
      )?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-info","label":!_vm.isSmallerScreen ? 'Maintenance Reviews' : ''}},[_c('div',{staticClass:"lists-view-tab"},[_c('reviews')],1)]):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }